export default "__VITE_ASSET__776aee85__"